import React from "react";
import { darkModeStepperNav } from "../../../../utils/constants";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { ReactComponent as Logo } from '../../../../images/Logo_svg.svg'
import { ReactComponent as LogoText } from '../../../../images/Logo_text.svg'

const StepperIcon = () => {
    const { darkMode } = useDarkModeStore();
    return <div
        style={{
            top: 0,
            zIndex: 100,
            paddingBottom: 2,
            position: 'sticky',
            background: darkMode ? darkModeStepperNav : 'white',
        }}>
        <div className="d-flex flex-row gap-3 align-items-center justify-content-center">
            <Logo width="40" height="40" />
            <LogoText width="120" height="95" />
        </div>
        <p
            className='fw-bold text-center ms-5 me-5'
            style={{ fontSize: 12, color: "#999999" }}
        >
            It will take u 5 minutes to finish the onboarding.
        </p>
    </div>
}

export default StepperIcon;